export default __webpack_public_path__ + "static/media/Icon feather-arrow-right.e264f1c6.svg";